import { TOrderStatus } from "../../../../types/orderStatus";

export const getOrders = (page?: number, status?: TOrderStatus) => ({
  type: "@saga/GET_ORDERS",
  payload: { page, status },
});
